module.exports = __webpack_public_path__ + "static/img/12.9682b030.gif";